import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Center from '@zenbusiness/zui/Center';
import Grid from '@zenbusiness/zui/Grid';
import PageContainer from '@zenbusiness/zui/PageContainer';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import * as ROUTES from '#client/constants/routes';
import { useLeadDetails } from '#client/hooks/useLeadDetails';
import { generateShoppingUiRedirectUrl } from '#client/utils/urls';

import * as Styled from './OrphanAccountOptions.style';

const OrphanAccountOptions = () => {
  const { data: leadDetails, loading: leadDetailsLoading } = useLeadDetails();
  const { formatMessage } = useIntl();

  // Get shopping URL based on lead details or fallback to general shop
  const shoppingUrl = generateShoppingUiRedirectUrl(leadDetails);

  const veloUrl = ROUTES.VELO_GUIDE;

  return (
    <PageContainer>
      <Center p={2}>
        <Styled.GridContainer>
          <Grid item>
            <SharedAsset alt="" height={92} src="/s2/raster/llc-formation.png" width={92} />
          </Grid>
          <Grid item>
            <Styled.ContentHeader
              title={
                <Text size="xl" weight="medium">
                  <FormattedMessage id="dashboard.orphanAccount.getStarted.header.title" />
                </Text>
              }
              subtitle={
                <Text size="md" weight="regular">
                  <FormattedMessage id="dashboard.orphanAccount.getStarted.header.subtitle" />
                </Text>
              }
            />
          </Grid>
          <Styled.CardsContainer>
            <Styled.OptionCard>
              <Styled.OptionCardInner>
                <Styled.OptionCardContent>
                  <Styled.CardTitle>
                    <FormattedMessage id="dashboard.orphanAccount.getStarted.startBusiness.title" />
                  </Styled.CardTitle>
                  <Styled.CardDescription size="md" color="secondary">
                    <FormattedMessage id="dashboard.orphanAccount.getStarted.startBusiness.description" />
                  </Styled.CardDescription>
                  <Button
                    loading={leadDetailsLoading}
                    clickstreamProps={{
                      elementName: 'orphan_account_option_button',
                      elementText: formatMessage({ id: 'dashboard.orphanAccount.getStarted.startBusiness.button' }),
                      linkDestination: shoppingUrl,
                    }}
                    href={shoppingUrl}
                    size="lg"
                    fullWidth
                    variant="contained"
                    color="secondary"
                  >
                    <FormattedMessage id="dashboard.orphanAccount.getStarted.startBusiness.button" />
                  </Button>
                </Styled.OptionCardContent>
              </Styled.OptionCardInner>
            </Styled.OptionCard>

            <Styled.OptionCard>
              <Styled.OptionCardInner>
                <Styled.OptionCardContent>
                  <Styled.CardTitle>
                    <FormattedMessage id="dashboard.orphanAccount.getStarted.askVelo.title" />
                  </Styled.CardTitle>
                  <Styled.CardDescription size="md" color="secondary">
                    <FormattedMessage id="dashboard.orphanAccount.getStarted.askVelo.description" />
                  </Styled.CardDescription>
                  <Button
                    clickstreamProps={{
                      elementName: 'orphan_account_option_button',
                      elementText: formatMessage({ id: 'dashboard.orphanAccount.getStarted.askVelo.button' }),
                      linkDestination: veloUrl,
                    }}
                    href={veloUrl}
                    size="lg"
                    fullWidth
                    variant="outlined"
                    color="primary"
                    sx={Styled.gradientButtonStyles()}
                  >
                    <FormattedMessage id="dashboard.orphanAccount.getStarted.askVelo.button" />
                  </Button>
                </Styled.OptionCardContent>
              </Styled.OptionCardInner>
            </Styled.OptionCard>
          </Styled.CardsContainer>
        </Styled.GridContainer>
      </Center>
    </PageContainer>
  );
};

export default OrphanAccountOptions;
